import React, { Component }    from 'react';
import LoadingSvg              from './LoadingSvg';
import PlaceGridItem           from './PlaceGridItem';
import './../css/PlaceList.css';
import './../css/App.css';

class PlaceGridView extends Component
{
    renderGridItems = () => {
        return this.props.places.map((place) =>
        {
            return (<PlaceGridItem key={ place.id } place={ place } />);
        });
    };

    render = () => {
        if (null === this.props.filter || this.props.geo.waiting)
        {
            return (
                <div className="places-grid">
                    <LoadingSvg />
                </div>
            );
        }
        else
        {
            if (0 === this.props.places.length)
            {
                return (
                    <div className="places-grid">
                        <p>{ this.props.filter.empty }</p>
                    </div>
                );
            }
            else
            {
                return (
                    <div className="places-grid">
                        <ul className="rig columns-3">
                            <div className="grid-container">{ this.renderGridItems() }</div>
                        </ul>
                    </div>
                );
            }
        }
    }

}

export default PlaceGridView;



// WEBPACK FOOTER //
// ./src/components/PlaceGridView.js